export const VIEW_MODE_CHANNEL_VIEW = 'channels/view-mode/channel-view'
export const VIEW_MODE_CHANNEL_GUIDE = 'channels/view-mode/channel-guide'
export const VIEW_MODE_CHANNEL_BANNER = 'channels/view-mode/channel-banner'
export const VIEW_MODE_CHANNEL_LIST = 'channels/view-mode/channel-list'
export const VIEW_MODE_FAVORITE_LIST = 'channels/view-mode/favorite-list'
export const TOGGLE_MUTED = 'channels/view-mode/muted'
export const FULLSCREEN_MODE = 'channels/view-mode/fullscreen'
